// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoBlock__vEQ48 {
  flex: 0 0 30%;
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  padding: 15px;
}
.infoBlock__vEQ48:first-child {
  border-right: unset;
}
@media (max-width: 900px) {
  .infoBlock__vEQ48 {
    flex: 0 0 50%;
  }
}

.infoLeftBlock__iWy0E {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  justify-content: space-between;
}

.infoTitle__g9zRv {
  font-size: 11px;
  height: 26px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}

.openAiBlock__UEYUj {
  display: flex;
  column-gap: 16px;
}

.openAi__Mdk3l {
  display: flex;
  align-items: center;
  column-gap: 5px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: var(--legend-for-header-text);
}

.openAiUrgency__PonCc {
  width: 10px;
  height: 10px;
}

.critical__i832b {
  background: var(--labels-outline-stroke-text-critical);
}

.high__nPvtk {
  background: var(--labels-outline-stroke-text-high);
}

.standard__ycB1R {
  background: var(--labels-outline-stroke-text-standard);
}

.openAiChart__mbKiE {
  width: 48px;
  height: 48px;
}

.skeletonText__lcxCM {
  width: 24px;
  height: 16px;
}

.skeletonChart__UJFtF {
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../src/pages/AssetHealthDetails/components/AssetHealthOpenAi/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,kDAAA;EACA,qDAAA;EACA,aAAA;AAzEF;AA2EE;EACE,mBAAA;AAzEJ;AA4EE;EAZF;IAaI,aAAA;EAzEF;AACF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,YAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oCAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,sDAAA;AAzEF;;AA4EA;EACE,kDAAA;AAzEF;;AA4EA;EACE,sDAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.infoBlock {\n  flex: 0 0 30%;\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  padding: 15px;\n\n  &:first-child {\n    border-right: unset;\n  }\n\n  @media (max-width: 900px) {\n    flex: 0 0 50%;\n  }\n}\n\n.infoLeftBlock {\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n  justify-content: space-between;\n}\n\n.infoTitle {\n  font-size: 11px;\n  height: 26px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n}\n\n.openAiBlock {\n  display: flex;\n  column-gap: 16px;\n}\n\n.openAi {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  color: var(--legend-for-header-text);\n}\n\n.openAiUrgency {\n  width: 10px;\n  height: 10px;\n}\n\n.critical {\n  background: var(--labels-outline-stroke-text-critical);\n}\n\n.high {\n  background: var(--labels-outline-stroke-text-high);\n}\n\n.standard {\n  background: var(--labels-outline-stroke-text-standard);\n}\n\n.openAiChart {\n  width: 48px;\n  height: 48px;\n}\n\n.skeletonText {\n  width: 24px;\n  height: 16px;\n}\n\n.skeletonChart {\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBlock": `infoBlock__vEQ48`,
	"infoLeftBlock": `infoLeftBlock__iWy0E`,
	"infoTitle": `infoTitle__g9zRv`,
	"openAiBlock": `openAiBlock__UEYUj`,
	"openAi": `openAi__Mdk3l`,
	"openAiUrgency": `openAiUrgency__PonCc`,
	"critical": `critical__i832b`,
	"high": `high__nPvtk`,
	"standard": `standard__ycB1R`,
	"openAiChart": `openAiChart__mbKiE`,
	"skeletonText": `skeletonText__lcxCM`,
	"skeletonChart": `skeletonChart__UJFtF`
};
module.exports = ___CSS_LOADER_EXPORT___;
